import styled from 'styled-components';
//
import Layout from '../../components/Layout';
import { Title } from '../../components/ui';
import { useEffect, useState } from 'react';
import { getCMS } from '../../api/services/systemService';
//

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5rem 0;
  gap: 2%;
  width: 100%;
  max-width: 100%;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
`;

// const DescTitleText = styled.p`
//   margin: 20px 0;
//   padding: 0;
//   font-size: 1.5rem;
//   font-weight: 700;
//   white-space: pre;
//   color: ${(props) => props.theme.colors.primaryBlue};
// `;

export default function AboutUsPage() {
  useEffect(() => {
    getDbCMS();
  }, []);

  const [content, setContent] = useState({
    title: '',
    contents: '',
  });

  const getDbCMS = async () => {
    const result = await getCMS('01');
    setContent(result.cms);
  };

  return (
    <Layout>
      <Container>
        <Title style={{ marginBottom: '30px' }}>{content.title}</Title>
        <TextContainer>
          <div dangerouslySetInnerHTML={{ __html: content.contents }} />
          {/* <img
            src={
              'https://edencorp.com/images/uploaded/Eden%20Marketing%20Corp%206621%20Wilson%20Ave%2090001_cropped_1000.jpeg'
            }
          />
          <DescTitleText>We are an Import/Export Destributor</DescTitleText>
          <BodyText size={'1rem'}>
            {`Eden Marketing Corp. is headquartered in Los Angeles, CA and has been importing and distributing to our US customers since 1979. Our\nproducts range from Asian housewares, small kitchen appliances and general merchandise items that are predominately from Japan, Korea, \nand China.`}
          </BodyText> */}
        </TextContainer>
      </Container>
    </Layout>
  );
}
